export function saltarBeneficiarios(observations) {
  return observations && false;
}

export function planType(observations) {

  if (observations.includes("CO001")) {
    return ["VG"];
  }
  if (observations.includes("CO002")) {
    return ["AP"];
  }
  if (observations.includes("CO101")) {
    return ["VG"];
  }
  if (observations.includes("CO102")) {
    return ["AP"];
  }
  if (observations.includes("CO201")) {
    return ["VG"];
  }
  if (observations.includes("CO202")) {
    return ["AP"];
  }

  return [];
}

export function procedimientoType(observations){
  if (observations.includes("CO001") || observations.includes("CO002")) {
    return "INCLUSION";
  }
  if (observations.includes("CO101") || observations.includes("CO102")) {
    return "AUMENTO";
  }
  if (observations.includes("CO201") || observations.includes("CO202")) {
    return "ACTUALIZACION";
  }
  return [];
}